export const name = '@shgysk8zer0/components';
export const version = '0.0.9';
export const url = `https://unpkg.com/${name}@${version}/`;
